import React from 'react';
import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
import 'primeicons/primeicons.css';

export default function AppShell() {
  const navigate = useNavigate();
  const routerLocation = useLocation();

  const items = [
    { label: 'Dashboard',       to: '/iqledger/dashboard',       icon: 'pi pi-home' },
    { label: 'Profile',         to: '/iqledger/profile',         icon: 'pi pi-user' },
    { label: 'Members',         to: '/iqledger/members',         icon: 'pi pi-users' },
    { label: 'Redaction Rules', to: '/iqledger/redaction-rules', icon: 'pi pi-shield' },
    { label: 'Settings',        to: '/iqledger/settings',        icon: 'pi pi-cog' }
  ];

  return (
    <div className="app-shell">
      <aside className="app-sidebar">
        <button className="app-sidebar-brand" onClick={() => navigate('/iqledger')}>
          <span className="dot" /> IQLedger
        </button>
        <nav className="app-sidebar-nav">
          {items.map(i => (
            <NavLink
              key={i.to}
              to={i.to}
              end
              className={({ isActive }) => {
                const isDashboard = i.label === 'Dashboard' && routerLocation.pathname === '/iqledger';
                return 'side-link' + ((isActive || isDashboard) ? ' active' : '');
              }}
            >
              <i className={i.icon} /> <span>{i.label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>

      <section className="app-body">
        <Outlet />
      </section>
    </div>
  );
}
